import HistoricalScoresBox from './HistoricalScoresBox'

export default HistoricalScoresBox
